import {ApplicationConfig, ErrorHandler, inject, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection} from '@angular/core';
import {InMemoryScrollingOptions, provideRouter, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimations} from "@angular/platform-browser/animations";
import {HttpClient, provideHttpClient, withInterceptors} from "@angular/common/http";
import {DateInterceptor, TokenInterceptor} from "./model/client/interceptor/interceptors";
import {provideTranslateService, TranslateLoader} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

import localeBr from '@angular/common/locales/br';
import localeBrRExtra from '@angular/common/locales/extra/br';
import {registerLocaleData} from '@angular/common';
import {FILE_UPLOAD_HANDLER} from "./view/components/govbr-ds/input-fileupload/input-fileupload.component";
import {CustomFileUploadHandler} from "./view/components/utils/custom-file-upload-handler";
import {PtmErrorHandlerService} from "./view/components/error/ptm-error-handler.service";
import {LegalReferencesViewmodelService} from "./viewmodel/legal-references.viewmodel.service";
import {PublicServiceViewmodelService} from "./viewmodel/public-service.viewmodel.service";
import {PublicHubViewmodelService} from "./viewmodel/public-hub.viewmodel.service";

registerLocaleData(localeBr, 'pt-BR', localeBrRExtra);

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({eventCoalescing: true}),
        provideRouter(routes, withInMemoryScrolling(scrollConfig)),
        provideAnimations(),
        provideAppInitializer(async () => {
            const legalRefs = inject(LegalReferencesViewmodelService);
            const services = inject(PublicServiceViewmodelService);
            const hubs = inject(PublicHubViewmodelService);
            await Promise.all([
                legalRefs.init(),
                services.init(),
                hubs.init()
            ]);
        }),
        provideHttpClient(
            withInterceptors([
                TokenInterceptor,
                DateInterceptor
            ])
        ),
        provideTranslateService({
            defaultLanguage: 'pt-br',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        {provide: LOCALE_ID, useValue: 'pt-BR'},
        {
            provide: FILE_UPLOAD_HANDLER,
            useClass: CustomFileUploadHandler
        },
        {
            provide: ErrorHandler,
            useClass: PtmErrorHandlerService
        },
    ]
};
